export var skeletonTextStyles = {
  root: function root(_ref) {
    var p = _ref.props,
        v = _ref.variables;
    return Object.assign({
      display: 'block',
      background: v.textBackground,
      height: v.textMediumHeight,
      width: v.textWidth
    }, p.size === 'smaller' && {
      height: v.textSmallerHeight
    }, p.size === 'small' && {
      height: v.textSmallHeight
    }, p.size === 'large' && {
      height: v.textLargeHeight
    }, p.size === 'larger' && {
      height: v.textLargerHeight
    });
  }
};
//# sourceMappingURL=skeletonTextStyles.js.map
